
(function(){
  if(customElements.get('velorart-video-showcase')) return;
  let activeShowcase=null;

  class VelorartVideoShowcase extends HTMLElement {
    connectedCallback(){
      this.grid=this.querySelector('.velorart-video-grid');
      this.modal=this.querySelector('[data-velorart-modal]')||this.modal;
      if(!this.grid||!this.modal) return;

      this.video=this.modal.querySelector('.velorart-modal-video');
      this.modalInner=this.modal.querySelector('.velorart-modal-inner');
      this.modalHeader=this.modal.querySelector('.velorart-modal-header');
      this.productRow=this.modal.querySelector('.velorart-modal-product');
      this.previous=this.querySelector('.velorart-mobile-arrow--prev');
      this.next=this.querySelector('.velorart-mobile-arrow--next');
      this.controller=new AbortController();
      const signal=this.controller.signal;
      const update=()=>{
        this.updateArrows();
        this.fitModal();
      };

      this.addEventListener('click',e=>this.onClick(e),{signal});
      this.addEventListener('keydown',e=>{
        if(e.target.matches('.velorart-video-card')&&(e.key==='Enter'||e.key===' ')){
          e.preventDefault();
          if(!e.repeat) e.target.click();
        }
      },{signal});
      this.modal.addEventListener('click',e=>{
        if(e.target.closest('.velorart-close')) this.closeModal();
      },{signal});
      this.modal.addEventListener('cancel',e=>{
        e.preventDefault();
        this.closeModal();
      },{signal});
      this.modal.addEventListener('close',()=>{
        if(!this.modal.open) this.closeModal();
      },{signal});
      this.grid.addEventListener('scroll',update,{passive:true,signal});
      window.addEventListener('resize',update,{signal});
      if(window.visualViewport){
        window.visualViewport.addEventListener('resize',()=>this.fitModal(),{signal});
      }
      this.video.addEventListener('loadedmetadata',()=>{
        if(this.video.videoWidth&&this.video.videoHeight){
          this.videoRatio=this.video.videoWidth/this.video.videoHeight;
          this.fitModal();
        }
      },{signal});
      this.resizeObserver=new ResizeObserver(update);
      this.resizeObserver.observe(this.grid);
      this.updateArrows();
    }

    disconnectedCallback(){
      if(this.controller) this.controller.abort();
      if(this.resizeObserver) this.resizeObserver.disconnect();
      if(this.modal){
        this.closeModal();
        if(!this.contains(this.modal)) this.modal.remove();
      }
    }

    updateArrows(){
      const maximum=Math.max(0,this.grid.scrollWidth-this.grid.clientWidth);
      const position=Math.min(maximum,Math.max(0,this.grid.scrollLeft));
      this.previous.hidden=position<=1;
      this.next.hidden=maximum-position<=1;
      this.previous.disabled=this.previous.hidden;
      this.next.disabled=this.next.hidden;
    }

    fitModal(){
      if(!this.modal.classList.contains('is-open')) return;
      const outer=getComputedStyle(this.modal);
      const inner=getComputedStyle(this.modalInner);
      const paddingX=parseFloat(inner.paddingLeft)+parseFloat(inner.paddingRight);
      const paddingY=parseFloat(inner.paddingTop)+parseFloat(inner.paddingBottom);
      const viewportHeight=Math.min(this.modal.clientHeight,window.visualViewport?.height||window.innerHeight);
      const availableWidth=Math.min(900,this.modal.clientWidth-parseFloat(outer.paddingLeft)-parseFloat(outer.paddingRight));
      const availableHeight=viewportHeight-parseFloat(outer.paddingTop)-parseFloat(outer.paddingBottom);
      const maximumVideoWidth=Math.max(1,availableWidth-paddingX);
      const minimumContentWidth=this.productRow.hidden?0:Math.min(maximumVideoWidth,parseFloat(inner.getPropertyValue('--velorart-footer-min-width')));
      const gap=parseFloat(inner.rowGap)*(this.productRow.hidden?1:2);
      const ratio=this.videoRatio||9/16;

      this.modalInner.style.width=availableWidth+'px';
      // Remeasure the product row as the panel narrows, so wrapped titles fit too.
      for(let i=0;i<3;i++){
        const footerHeight=this.productRow.hidden?0:this.productRow.getBoundingClientRect().height;
        const maximumVideoHeight=Math.max(1,availableHeight-paddingY-this.modalHeader.getBoundingClientRect().height-gap-footerHeight);
        const videoWidth=Math.min(maximumVideoWidth,maximumVideoHeight*ratio);
        this.modalInner.style.width=(Math.max(videoWidth,minimumContentWidth)+paddingX)+'px';
        this.video.style.width=videoWidth+'px';
        this.video.style.height=(videoWidth/ratio)+'px';
      }
    }

    onClick(e){
      const arrow=e.target.closest('.velorart-mobile-arrow');
      if(arrow){
        const direction=arrow===this.previous?-1:1;
        this.grid.scrollBy({left:direction*this.grid.clientWidth*.55,behavior:'smooth'});
        return;
      }

      const card=e.target.closest('.velorart-video-card');
      if(!card) return;
      if(activeShowcase&&activeShowcase!==this) activeShowcase.closeModal();
      this.returnFocus=card;
      // Keep the popup above the product column's sticky stacking context.
      document.body.appendChild(this.modal);
      this.videoRatio=parseFloat(card.dataset.videoAspectRatio)||9/16;
      if(card.dataset.videoPoster){
        this.video.poster=card.dataset.videoPoster;
      }else{
        this.video.removeAttribute('poster');
      }
      this.video.src=card.dataset.video;
      this.modal.querySelector('.velorart-product-title').textContent=card.dataset.productTitle||'';
      const productImage=this.modal.querySelector('.velorart-product-image');
      if(card.dataset.productImage){
        productImage.src=card.dataset.productImage;
      }else{
        productImage.removeAttribute('src');
      }
      productImage.alt=card.dataset.productTitle||'';
      const productLink=this.modal.querySelector('.velorart-view-artwork');
      const productUrl=card.dataset.productUrl||'';
      this.productRow.hidden=!productUrl;
      if(productUrl){
        productLink.href=productUrl;
      }else{
        productLink.removeAttribute('href');
      }
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden','false');
      this.lockPageScroll();
      if(!this.modal.open) this.modal.showModal();
      activeShowcase=this;
      this.fitModal();
      const playback=this.video.play();
      if(playback) playback.catch(()=>{});
    }

    closeModal(){
      if(!this.modal.open&&!this.modal.classList.contains('is-open')&&!this.scrollLock) return;
      if(this.modal.open) this.modal.close();
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden','true');
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.unlockPageScroll();
      if(activeShowcase===this) activeShowcase=null;
      if(this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
      this.returnFocus=null;
    }

    lockPageScroll(){
      if(this.scrollLock) return;
      const root=document.documentElement;
      const body=document.body;
      const scrollbarWidth=window.innerWidth-root.clientWidth;
      const paddingRight=parseFloat(getComputedStyle(body).paddingRight)||0;
      const styles=[];
      for(const [element,properties] of [
        [root,['overflow','scroll-behavior']],
        [body,['position','top','left','width','overflow','padding-right']]
      ]){
        for(const property of properties){
          styles.push({element,property,value:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)});
        }
      }
      this.scrollLock={x:window.scrollX,y:window.scrollY,styles};
      root.style.setProperty('overflow','hidden','important');
      root.style.setProperty('scroll-behavior','auto','important');
      body.style.setProperty('position','fixed','important');
      body.style.setProperty('top',-this.scrollLock.y+'px','important');
      body.style.setProperty('left',-this.scrollLock.x+'px','important');
      body.style.setProperty('width','100%','important');
      body.style.setProperty('overflow','hidden','important');
      if(scrollbarWidth>0) body.style.setProperty('padding-right',paddingRight+scrollbarWidth+'px','important');
    }

    unlockPageScroll(){
      if(!this.scrollLock) return;
      const {x,y,styles}=this.scrollLock;
      this.scrollLock=null;
      const restore=({element,property,value,priority})=>{
        if(value) element.style.setProperty(property,value,priority);
        else element.style.removeProperty(property);
      };
      for(const style of styles){
        if(style.property!=='scroll-behavior') restore(style);
      }
      window.scrollTo(x,y);
      restore(styles.find(style=>style.property==='scroll-behavior'));
    }
  }

  customElements.define('velorart-video-showcase',VelorartVideoShowcase);
})();
